import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Button,
} from "@mui/material";

const NewSqlDialog = ({
  open,
  newSqlSequence,
  newSqlDescription,
  newSqlError,
  newSqlLoading,
  onClose,
  onChangeSqlSequence,
  onChangeSqlDescription,
  onCreateSqlFile,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Create SQL migration for active change</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Files will be created under <code>sql_migrations/</code> using the
          pattern: CHG-XXX-SEQ.sql (e.g. CHG-047-001.sql).
        </Typography>
        <TextField
          autoFocus
          margin="dense"
          label="Sequence (e.g. 001)"
          fullWidth
          value={newSqlSequence}
          onChange={(e) => onChangeSqlSequence(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Description (optional)"
          fullWidth
          value={newSqlDescription}
          onChange={(e) => onChangeSqlDescription(e.target.value)}
          sx={{ mt: 1 }}
        />
        {newSqlError && (
          <Typography
            variant="caption"
            color="error"
            sx={{ display: "block", mt: 1 }}
          >
            {newSqlError}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={newSqlLoading}>
          Cancel
        </Button>
        <Button
          onClick={onCreateSqlFile}
          variant="contained"
          disabled={newSqlLoading}
        >
          {newSqlLoading ? "Creating..." : "Create SQL"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NewSqlDialog;